import { useCallback, useEffect, useState } from 'react'
import type { UseFormReturn } from 'react-hook-form'
import type { AgencyFormSchemaType } from '@/components/agencies/agency-form.schema'

interface UseAgencyLogoProps {
  logoUrl?: string | null
  form: UseFormReturn<AgencyFormSchemaType>
}

export interface UseAgencyLogoReturn {
  logoPreviewUrl: string | null
  handleLogoChange: (file: File | null) => void
  handleLogoRemove: () => void
}

export const useAgencyLogo = ({ logoUrl, form }: UseAgencyLogoProps): UseAgencyLogoReturn => {
  const [logoPreviewUrl, setLogoPreviewUrl] = useState<string | null>(logoUrl ?? null)
  const [logoFile, setLogoFile] = useState<File | null>(null)

  useEffect(() => {
    setLogoPreviewUrl(logoUrl ?? null)
  }, [logoUrl])

  const handleLogoChange = useCallback(
    (file: File | null): void => {
      if (file) {
        const url = URL.createObjectURL(file)
        setLogoPreviewUrl(url)
        setLogoFile(file)
        form.setValue('logoUrl', url)
      }
    },
    [form]
  )

  const handleLogoRemove = useCallback((): void => {
    if (logoPreviewUrl && logoFile) {
      URL.revokeObjectURL(logoPreviewUrl)
    }
    setLogoPreviewUrl(null)
    setLogoFile(null)
    form.setValue('logoUrl', null)
  }, [logoPreviewUrl, logoFile, form])

  return {
    logoPreviewUrl,
    handleLogoChange,
    handleLogoRemove,
  }
}
